<template>
  <div class="overflow-hidden rounded-lg max-lg:rounded-none aspect-3/2">
    <img
      class="size-full object-cover align-bottom cursor-pointer"
      :src="getRvImagePlaceHolder"
      alt=""
      @click="goToEditRvAddPhotos"
    >
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  rvId: string
}>()

const localePath = useLocalePath()

const { getStaticImage } = useImage()
const getRvImagePlaceHolder = computed(() => getStaticImage({
  path: '/web/images/add-photos-placeholder.png',
}))

const { dashboardMode } = useBaseName()
async function goToEditRvAddPhotos() {
  await navigateTo(
    localePath({
      name: 'dashboard-rvs-rvId-photos',
      params: {
        rvId: props.rvId,
        dashboard: dashboardMode.value,
      },
    }),
  )
}
</script>
